import {useSelector} from "react-redux";
import {css} from "@emotion/react";

import {p, w100} from "@pg-design/helpers-css";

import {IRPStore} from "../../../app/rp_reducer";
import {MapHeader} from "../../map/components/MapHeader";
import {ExpandablePanel} from "./atoms/ExpandablePanel";

interface IProps {
    isOpen: boolean;
    handleClose: () => void;
    generatedDescriptionAllowed: boolean;
    onShowGeneratedDescription: () => void;
}

export const ExpandablePanelMapHeader = (props: IProps) => {
    const pageTitle = useSelector((state: IRPStore) => state.metaData.standardMetaData.title);
    const offerListData = useSelector((state: IRPStore) => state.offerListMap.list);
    const selectedRegion = useSelector((state: IRPStore) => state.offerListMap.selectedRegion);

    return (
        <ExpandablePanel isOpen={props.isOpen} handleClose={props.handleClose} css={expandableContentMapHeader}>
            <MapHeader
                pageTitle={pageTitle}
                offerCount={offerListData.count}
                propertiesCount={offerListData.propertiesCount}
                selectedRegion={selectedRegion}
                generatedDescriptionAllowed={props.generatedDescriptionAllowed}
                onShowGeneratedDescription={props.onShowGeneratedDescription}
            />
        </ExpandablePanel>
    );
};

const expandableContentMapHeader = css`
    ${p(4, 3, 1, 3)};
    ${w100};
    height: auto;
    background-color: #fff;
`;
import {useSelector} from "react-redux";
import {css} from "@emotion/react";

import {p, w100} from "@pg-design/helpers-css";

import {IRPStore} from "../../../app/rp_reducer";
import {MapHeader} from "../../map/components/MapHeader";
import {ExpandablePanel} from "./atoms/ExpandablePanel";

interface IProps {
    isOpen: boolean;
    handleClose: () => void;
    generatedDescriptionAllowed: boolean;
    onShowGeneratedDescription: () => void;
}

export const ExpandablePanelMapHeader = (props: IProps) => {
    const pageTitle = useSelector((state: IRPStore) => state.metaData.standardMetaData.title);
    const offerListData = useSelector((state: IRPStore) => state.offerListMap.list);
    const selectedRegion = useSelector((state: IRPStore) => state.offerListMap.selectedRegion);

    return (
        <ExpandablePanel isOpen={props.isOpen} handleClose={props.handleClose} css={expandableContentMapHeader}>
            <MapHeader
                pageTitle={pageTitle}
                offerCount={offerListData.count}
                propertiesCount={offerListData.propertiesCount}
                selectedRegion={selectedRegion}
                generatedDescriptionAllowed={props.generatedDescriptionAllowed}
                onShowGeneratedDescription={props.onShowGeneratedDescription}
            />
        </ExpandablePanel>
    );
};

const expandableContentMapHeader = css`
    ${p(4, 3, 1, 3)};
    ${w100};
    height: auto;
    background-color: #fff;
`;
